"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldIcon = exports.Button = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("./Button.sizes"));

var _Button2 = _interopRequireDefault(require("./Button.theme"));

var FieldIcon = _styledComponents.default.i.withConfig({
  componentId: "sc-mzmykx-0"
})(["display:inline-block;align-self:center;z-index:2;svg{display:block;}"]);

exports.FieldIcon = FieldIcon;

var Button = _styledComponents.default.button.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['pill', 'fluid', 'color', 'appearance', 'size'].includes(prop);
  }
}).withConfig({
  componentId: "sc-mzmykx-1"
})(["display:inline-flex;align-self:flex-start;justify-content:center;user-select:none;vertical-align:middle;outline:none;transition:0.2s all linear;position:relative;overflow:hidden;word-spacing:initial;transform:scale(0,0,0);text-shadow:none;text-align:center;", " ", " ", " &:after{content:'';display:block;position:absolute;width:100%;height:100%;top:0px;left:0px;pointer-events:none;background-repeat:no-repeat;background-position:50% center;transform:scale(10,10);opacity:0;transition:transform 0.5s ease 0s,opacity 1s ease 0s;}&:active{&:after{transform:scale(0,0);opacity:0.2;transition:all 0s ease 0s;}}&:after{background-image:radial-gradient(circle,rgb(11,12,16) 10%,transparent 10%);}&:hover{text-decoration:none;}"], function (_ref) {
  var theme = _ref.theme,
      fluid = _ref.fluid;
  return (0, _styledComponents.css)(["width:", ";font-family:'", "',sans-serif;"], fluid ? '100%' : 'auto', theme.fonts.default);
}, function (_ref2) {
  var _buttonSizes$size;

  var theme = _ref2.theme,
      size = _ref2.size,
      pill = _ref2.pill;
  var btnSize = (_buttonSizes$size = _Button.default[size]) !== null && _buttonSizes$size !== void 0 ? _buttonSizes$size : _Button.default[theme.sizes.button];
  return (0, _styledComponents.css)(["border-radius:", ";font-size:", "px;letter-spacing:", "px;line-height:", "px;padding-top:", "px;padding-right:", "px;padding-bottom:", "px;padding-left:", "px;font-weight:", ";", "{&.left-icon{margin-right:", "px;}&.right-icon{margin-left:", "px;}svg{width:", "px;height:", "px;}}"], pill || theme.pill ? '50vh' : btnSize.borderRadius + 'px', btnSize.fontSize, btnSize.letterSpacing, btnSize.lineHeight, btnSize.padding.top, btnSize.padding.right, btnSize.padding.bottom, btnSize.padding.left, _tokens.fontWeight[btnSize.fontWeight], FieldIcon, btnSize.icon.margin, btnSize.icon.margin, btnSize.icon.width, btnSize.icon.height);
}, function (_ref3) {
  var theme = _ref3.theme,
      color = _ref3.color,
      appearance = _ref3.appearance;
  var buttonTheme = (0, _Button2.default)(theme.colors[color]);
  return (0, _styledComponents.css)(["", " &:disabled{", ";}"], buttonTheme[appearance], buttonTheme.disabled);
});

exports.Button = Button;